import { useMemo } from 'react';

import { useChildRunsQueryParams } from '@/Pages/Run/utils/useChildRunsQueryParams';
import { useRun, useRunsQuery } from '@/hooks/useSwr';

import { USE_RUN_OPTIONS } from '../constants';
import { parseLangGraphCheckpointNs } from '../utils';

export const useLLMRunsForNode = ({
  runId,
  nodeName,
  nodeId,
  getChildLLMRuns,
}: {
  runId: string;
  nodeName: string;
  nodeId: string;
  getChildLLMRuns: boolean;
}) => {
  const { data: run } = useRun({
    id: runId,
    options: USE_RUN_OPTIONS(10),
  });
  const runsQuery = useChildRunsQueryParams({
    traceId: runId ?? undefined,
    run,
    rootRun: run,
  });

  const { data: childRuns } = useRunsQuery(
    runsQuery,
    { datasetShareToken: undefined },
    {
      keepPreviousData: false,
    }
  );
  const llmRunsForNode = useMemo(
    () =>
      childRuns?.runs?.filter((r) => {
        if (r.run_type !== 'llm') return false;
        const { langgraph_checkpoint_ns } = r.extra?.metadata ?? {};
        if (!langgraph_checkpoint_ns) return false;
        const parsedCheckpointNs = parseLangGraphCheckpointNs(
          langgraph_checkpoint_ns
        );
        if (!parsedCheckpointNs) return false;
        if (getChildLLMRuns) {
          return parsedCheckpointNs.some(
            (x) => x.name === nodeName && x.id === nodeId
          );
        } else {
          return (
            parsedCheckpointNs.at(-1)?.name === nodeName &&
            parsedCheckpointNs.at(-1)?.id === nodeId
          );
        }
      }),
    [childRuns, nodeId, nodeName, getChildLLMRuns]
  );
  return llmRunsForNode;
};
